import { Badge } from '@/components/shadcn/badge'
import { PercentageCardConfig, CardData } from '../types'
import { IconArrowDownOutline } from '@icons/IconArrowDownOutline'
import { IconArrowUpOutline } from '@icons/IconArrowUpOutline'
import clsx from 'clsx'

interface PercentageProps {
  config: PercentageCardConfig
  data: CardData
}

export function Percentage({ config, data }: PercentageProps) {
  const { valueChangeLabel } = config
  const { value, valueChange } = data

  const hasValueChange = valueChange !== undefined && valueChange !== null

  const isNegative = hasValueChange && valueChange < 0
  return (
    <div className="flex h-full w-full items-center justify-center">
      <div className="flex flex-col gap-4">
        <div className="m-auto text-4xl font-bold">
          {value}
          <span className="text-3xl font-light">%</span>
        </div>
        {hasValueChange && valueChangeLabel && (
          <div className="flex items-center gap-x-2 text-xs text-foreground/60">
            <Badge
              variant="outline"
              className={clsx('gap-x-1', {
                'border-red-700 bg-red-100 text-red-700': isNegative,
                'border-green-700 bg-green-100 text-green-700': !isNegative,
              })}
            >
              {isNegative ? <IconArrowDownOutline size={10} /> : <IconArrowUpOutline size={10} />}
              {Math.abs(valueChange)}%
            </Badge>
            {valueChangeLabel}
          </div>
        )}
      </div>
    </div>
  )
}
